import { createFileRoute, redirect } from '@tanstack/react-router';
import {
  getAuthenticated,
  getAuthtoken,
  getSelectedEntityId,
  getUrlParamsOnPageLoad,
  setUrlParamsOnPageLoad,
} from 'stores/useAuthStore';
import HomePage from 'containers/HomePage';
import { entitiesQueryOptions } from 'containers/Entities/hooks/useEntities';
import { organizationsQueryOptions } from 'containers/Organizations/hooks/useOrganizations';
import { currentUserQueryOptions } from 'containers/User/hooks/useUserAccountSync';
import { AppLoader } from '../-components/AppLoader';
import { AppShellSkeleton } from '../-components/skeletons';

export function AuthenticatedPending() {
  return getAuthenticated() && getAuthtoken() ? (
    <AppShellSkeleton />
  ) : (
    <AppLoader />
  );
}

export const Route = createFileRoute('/_authenticated')({
  beforeLoad: ({ location }) => {
    if (!getAuthenticated() || !getAuthtoken()) {
      const hash = location.hash ? `#${location.hash}` : '';
      const target = `${location.pathname}${location.searchStr}${hash}`.replace(
        /^\/+/,
        ''
      );
      if (target) {
        const params = new URLSearchParams(getUrlParamsOnPageLoad());
        params.set('redirect', target);
        setUrlParamsOnPageLoad(`?${params.toString()}`);
      }
      throw redirect({
        to: '/login',
        search: target ? { redirect: target } : {},
      });
    }
  },
  loader: ({ context }) => {
    const authToken = getAuthtoken();
    if (!authToken) return;
    const entityId = getSelectedEntityId();
    const { queryClient } = context;
    queryClient.prefetchQuery(currentUserQueryOptions(authToken));
    queryClient.prefetchQuery(entitiesQueryOptions(authToken, entityId));
    if (Number.isFinite(entityId)) {
      queryClient.prefetchQuery(
        organizationsQueryOptions(authToken, entityId)
      );
    }
  },
  pendingComponent: AuthenticatedPending,
  pendingMs: 0,
  component: HomePage,
});
